module.exports = __webpack_public_path__ + "img/property_gross_area_filled.71d57d6.svg";